import { createFileRoute, useRouter } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: () => {
    const router = useRouter();
    router.navigate({ to: '/companies' });
    return null;
  },
});
